import axios from 'axios';

export const getToken = async () => {
	const url = 'http://localhost:6060/v1/getToken';
	const body = {
		username: 'mario@mariokart.com',
		password: 'password',
	};

	const response = await axios.post(url, body);
	const returnValue = response.data.access_token;
	return returnValue;
};
